export default {
  // 通用
  cancel: "Cancelar",
  save: "Guardar",
  sure: "Aceptar",
  state: "Estado",
  operation: "Operación",
  prompt: "Pregunte",
  pleaseChoose: "Por favor elija",
  updateSuccess: "Actualización correcta",
  closeAccountSuccess: "Cuenta cerrada correctamente",
  email: "Correo electrónico",
  customerId: "Identificación de cliente",
  sureDelete: "¿Estas seguro que quieres borrarlo?",
  deleteSuccess: "Eliminardo con éxito",
  addSuccess: "Añadido con éxito",
  saveSuccess: "Guardado con éxito",
  operateSuccess: "Operación exitosa",
  message: "Mensaje",
  refresh: "Actualizar",
  yes: "Si",
  no: "No",
  import: "Importar",
  importFilesuccess: "Archivo importado correctamente",
  exportFilesuccess: "Archivo exportado correctamente",
  export: "Exportar",
  browse: "Navegador",
  home: "Hogar", // 翻译？
  copySuccess: "Replicado con éxito",
  pleaseInput: "Por favor, introduzca",
  emailError: "El formato del correo electrónico es incorrecto",
  unSavedWarning: "Tiene datos sin guardar, guarde y agregue",
  editUnSavedWarning: "Primero guarde el elemento de edición actual",
  loadMore: "Haga clic para cargar más",
  noData: "Sin datos",
  noMoreData: "No hay mas datos",
  delete: "Borrar",
  copy: "Copiar",
  edit: "Editar",
  pleaseChooseData: "Seleccione los datos a guardar",
  total: "Total",
  exportPanel: "Exportar a la central",
  importPanel: "Importar desde la central",
  salesChannel: "Canal de ventas",
  lastLoginDate: "Última fecha de inicio de sesión",
  globalLoadingText:
    "Esta operación puede tardar varios minutos en procesarse ...",
  globalLoading: "Cargando…",
  all: "Todas",
  empty: "VACÍO",
  notEmpty: "NO VACÍO",
  version: "Versión",
  logo: "logo",
  help: "Ayuda",
  // 注册时的滑块组件
  swipeRight: "Desliza hacia la derecha para completar el puzzle",
  // 登录
  account: "Cuenta",
  accountEmpty: "La cuenta no puede estar vacía",
  confirmPassword: "Confirmar contraseña",
  customerIdCode: "Código de identificación de cliente",
  customerName: "Nombre del cliente",
  forgotPassword: "¿Olvidó la contraseña?",
  sureResetPassword: "¿Está seguro de restablecer tu contraseña?",
  loginCheck: "La cuenta o la contraseña no pueden estar vacías",
  optionalInformation: "Información opcional",
  password: "Contraseña",
  register: "Registrar",
  rememberMe: "Recuérdame",
  systemName: "Herramienta de configuración",
  signIn: "Registrarse",
  signOutPrompt: "¿Está seguro de que desea salir del sistema?",
  nameEmpty: "El nombre no puede estar vacío",
  passwordEmpty: "La contraseña no puede estar vacía",
  confirmPasswordEmpty: "La contraseña de confirmación no puede estar vacía",
  phoneEmpty: "El teléfono no puede estar vacío",
  emailEmpty: "El correo electrónico no puede estar vacío",
  registerSuccess:
    "Por favor revise su correo electrónico para continuar con el proceso de registro.",
  tryAgain: "Inténtalo de nuevo",
  unagree: "Marque para aceptar los términos y condiciones",
  // resetPasswordSuccess: 'Password reset successfully, please go to email to confirm',
  resetPasswordSuccess:
    "Si el nombre de usuario coincide con nuestros registros, se enviará un correo electrónico para restablecer la contraseña",
  notModified: "No lo has modificado",
  unsavedRemind: "Tiene cambios no confirmados. ¿Quiere guardarlos?",
  identityInvalid:
    "La información de identidad no es válida, vuelva a iniciar sesión",
  // 配置文件
  createNewConfigFile: "Crear un nuevo archivo de configuración",
  createNewProject: "Crear un nuevo proyecto",
  openExistingProject: "Abrir proyecto existente",
  loadConfigFile: "Cargar un archivo de configuración existente",
  // 顶部head
  userInfo: "Información de usuario",
  changePassword: "Cambiar la contraseña",
  myProjects: "Mis proyectos",
  accountManagement: "Administración de cuentas",
  signOut: "Desconectar",
  // 修改密码
  currentPassword: "Contraseña actual",
  newPassword: "Nueva contraseña",
  confirmNewPassword: "Confirmar la nueva contraseña",
  checkCurrentPwd: "La contraseña actual no puede estar vacía",
  checkNewPwd: "La nueva contraseña no puede estar vacía",
  checkConfirm: "La confirmación de la nueva contraseña no puede estar vacía",
  checkConfirmSame:
    "La contraseña de confirmación no es la misma que la nueva contraseña",
  currentNewPasswordCheck:
    "La nueva contraseña no puede ser la misma que la contraseña actual",
  changePwdSuccess: "Contraseña cambiada con éxito",
  // 个人信息
  name: "Nombre",
  language: "Idioma",
  emailAddress: "Dirección de correo electrónico",
  phone: "Teléfono",
  closeAccount: "Cerrar cuenta",
  closeAccountPermanently:
    "Elimina permanentemente la información de la cuenta y los datos de los servicios.",
  closeAccountPermanentlyAll:
    "El cierre de su cuenta eliminará permanentemente toda su información y ya no podrá utilizar ninguno de los servicios.",
  // 项目信息
  projectDialogNew: "Información del proyecto",
  projectDialogEdit: "Editar proyecto",
  projectName: "Nombre",
  projectSite: "Nombre del proyecto",
  projectNote: "Nota",
  projectPanelsList: "Central",
  projectPanelMode: "Modo Panel",
  projectPanelTypeSingle: "Independiente",
  projectPanelTypeNetwork: "Red",
  projectPaneNo: "ID",
  projectPaneNote: "Descripción",
  projectNewSuccess: "Creado con éxito",
  editTableError: "Guarde la tabla editada",
  myProjectDialog: "Mis proyectos",
  projectTablesite: "Nombre del proyecto",
  projectTablepanelsNumber: "NÚMERO DE CENTRALES",
  projectTablecreatedTime: "FECHA DE CREACIÓN",
  projectTablemodifyTime: "FECHA DE EDICIÓN",
  projectTablenotes: "NOTAS",
  projectTableDelete: "Borrado exitoso",
  projectEditSuccess: "Actualización correcta",
  projectTableCopy: "copiar con éxito",
  projectTableEdit: "Editar proyecto",
  projectTableDown: "Descarga con éxito",
  projectTablePanelWarning: "Numero de centrales",
  projectLeadTitle: "Importar archivo",
  projectLeadRowName: "Seleccione Archivo",
  projectLeadRowButtom: "Subir",
  projectLeadRowButtomselectBefore: "Seleccione",
  folderLeadSuccess: "Importación de carpeta con éxito",
  projectLeadSuccess: "Importación del proyecto con éxito",
  projectAddRequired: "Los elementos obligatorios están incompletos",
  projectSelectPanels: "Seleccionar central",
  projectInfoPanelTheadPanelNo: "CENTRAL NO.",
  projectInfoPanelTheaddesc: "Descripción",
  projectInfoPanelsWarning: "Ningúna central seleccionada",
  panelDetail: "Detalle de la central",
  panelAddSuccess: "Panel añadido con éxito",
  panelUpdateSuccess: "Panel actualizado correctamente",
  panelDeleteSuccess: "Panel borrado correctamentel",
  // 账号管理
  disable: "Anulado",
  disabled: "Deshabilitado",
  enable: "Habilitar",
  enabled: "Habilitado",
  activate: "Activar",
  activated: "Activado",
  inactivated: "Desactivado",
  disabledSuccess: "Desactivado con éxito",
  activateSuccess: "Activado con éxito",
  enabledSuccess: "Habilitado con éxito",
  // 子菜单
  readonlyInformation: "Historico de la central",
  deviceTable: "Dispositivos de lazo",
  zoneDelays: "Retardos de zona SND + FR",
  daynightSchedule: "Configuración día / noche",
  advancedProgramming: "Programación avanzada",
  systemSettings: "Ajustes del sistema",
  myDownload: "Mis descargas",
  // 设备
  loop: "Lazo",
  channel: "Canal",
  address: "Dirección",
  type: "Tipo",
  description: "Descripción",
  zone: "Zona",
  group: "Grupo",
  sensitivityDuringProfileL1: "Sensibilidad durante el perfil L1",
  sensitivityDuringProfileL2: "Sensibilidad durante el perfil L2",
  sensitivityDuringProfileL3: "Sensibilidad durante el perfil L3",
  deviceExportSuccess: "Exportación exitosa. Descargue en 'Mis descargas '",
  // sensitivityTips: 'Sensitivity tips',
  // profile: 'Profile',
  // sensitivitySmoke: 'Sensitivity smoke',
  // 校验规则
  outOfRange: "Los números están fuera de rango",
  tooLong: "Hay demasiados caracteres",
  // Zone SDN+FR delays
  activeSNDByDET: "Activar SND para DET",
  doesSNDDelayApplyToDETAlarms: "Aplicar retardo SND para DET",
  SNDDelay: "Retardo SND (s)",
  activeSNDByMCP: "Activar SND para MCP",
  doesSNDDelayApplyToMCPAlarms: "Aplicar retardo SND para MCP",
  activeFRByDET: "Activar FR para DET", //
  doesFRDelayApplyToDETAlarms: "Aplicar retardo FR para DET",
  FRDelay: "Retardo FR (s)",
  activeFRByMCP: "Activar FR para MCP",
  doesFRDelayApplyToMCPAlarms: "Aplicar retardo FR para MCP",
  resoundSoundersIfNewZoneInAlarm: "Sirenas resonantes si nueva zona en alarma",
  // schedule
  week: "Semana",
  dayStart: "Inicio Dia (Activar retardos a esta hora)",
  sensitivityProfileDuringDay: "Perfil de sensibilidad durante el día",
  nightStart: "Inicio Noche (Desactivar retardos a esta hora)",
  sensitivityProfileDuringNight: "Perfil de sensibilidad durante la noche",
  monday: "Lunes",
  tuesday: "Martes",
  wednesday: "Miércoles",
  thursday: "Jueves",
  friday: "Viernes",
  saturday: "Sábado",
  sunday: "Domingo",
  notSet: "NO ESTABLECIDO",
  // 编码
  actionNumber: "Número de acción",
  scenario: "Escenario",
  activation: "Activación",
  line: "Línea",
  alarmType: "Tipo de alarma",
  quantityOfAlarms: "Numero de alarmas",
  groupToActivate: "Grupo para activar",
  combination: "Combinación",
  delay: "Retardo",
  hold: "¿PUlSOS? (MAX 63 s; 0-> NO)",
  twoStages: "Dos Etapas",
  twoStagesVersionTip:
    "Esta función requiere software de controlador versión 0.6.10 o superior",
  actionNumLimit: "¡El número de acciones  no puede exceder las 400 líneas!",
  scenarioLimit: "¡No puede exceder de 32 líneas!",
  activationLimit: "¡No puede exceder de 16 líneas!",
  // system setting
  maintenanceCompanyDetails: "Datos de contacto para mantenimiento",
  company: "Empresa",
  telephone: "Teléfono",
  projectName: "Nombre del proyecto",
  personOfContact: "Persona de contacto",
  setLanguage: "Idioma",
  loopClass: "Clase de lazo",
  setPassword: "Configurar password",
  setupPrinter: "Configurar impresora",
  systemConfiguration: "Configuración sistema",
  notes: "NOTAS",
  classB: "Clase B",
  classA: "Clase A",
  off: "off",
  on: "on",
  operatorPassword: "Password de operador",
  installerPassword: "Password de instalador",
  power: "Alimentación",
  mode: "Modo",
  eventsPrinted: "Impresión eventos",
  systemLoopCard: "# de tarjetas de lazo en el sistema",
  loopsInTheSystem: "# de lazos en el sistema",
  LEDPanels: "# tarjetas de LED",
  chargerCards: "# cargador de baterias",
  systemBoards: "# Nº de tarjetas IO en el sistema",
  systemNetwork: "# Nº de tarjetas de red en el sistema",
  twoStagesOAT: "Tiempo de acceso del operador (s)",
  twoStagesIDT: "Tiempo de investigación (s)",
  mark: "Region",
  user: "Usuario",
  time: "Tiempo",
  // information-info
  timeAndDateTheConfig: "Hora y fecha en que se guardó la configuración",
  serialNumber: "Número de serie",
  firmwareVersions: "Versiones de firmware",
  dateOfLastConfig: "Fecha del último cambio de configuración en la central",
  eventLog: "Registro de eventos",
  operatorPasswordCheck: "La contraseña del operador no tiene 3 dígitos",
  installerPasswordCheck: "La contraseña del instalador no tiene 10 dígitos",
  // zone-setting
  zoneSettings: "Configuración de zona",
  zoneGroupTable: "Tabla de Zona/Grupo",
  //silenceableGroup
  silenceableGroup: "Grupo Silenceable",
  configureNetwork: "Configurar la información de la red",
  networkingInformation: "Información de la red",
  localAddr: "Dirección local",
  networkMode: "Modo de red",
  networkClass: "Categoría de red",
  dataTransferDevice: "Equipo de transmisión de datos",
  sendFilter: "Enviar filtro",
  send: "Enviar",
  doNotSend: "No enviar",
  Alarm: "Alarma",
  Fault: "Avería",
  Disable: "Anulado",
  Reset: "Reset",
  Silence: "Silenciar",
  Time: "Tiempo",
  Delay: "Retardo",
  sendNetMap: "Configurar el mapa de la red",
  startAddr: "Dirección inicio",
  endAddr: "Dirección final",
  acceptanceFiltering: "Filtro de aceptación",
  reception: "Recepción",
  noReception: "No hay recepción",
  addressCheck:
    "La dirección inicial no puede ser mayor que la dirección final",
  notDataFill: "Datos no rellenados",
  //setIoCard
  setIoCard: "Configurar la tarjeta io",
  IOBoard: "Tarjeta IO",
  Func: "Func",
  allowedMaxLoad: "Carga máxima permitida",
  FaultCheck: "Averías",
  none: "Ninguno",
  Output: "Salida",
  Feedback: "Confirmación",
  RTFAULT: "RT-Avería",
  groupBySndCK: "Activar grupo por la tecla de control SND",
  // my download
  filename: "Nombre del archivo",
  status: "Estado",
  startTime: "Hora de inicio",
  endTime: "Hora de finalización",
  download: "Descargar",
  inExport: "En la exportación",
  success: "Éxitoso",
  failure: "Fallo",
  templateFile: "Archivo de plantilla",
  importDeviceMsg: "Importar una tabla de dispositivos existente",
  importZoneDelays: "Importar un conjunto de retardos de zona existente",
  importAdvance:
    "Importar una programación avanzada existente, incluya acción, escenario y activación",
  // register success
  successAccoutRequest: "Solicitud de cuenta exitosa",
  accountAdministrator:
    "Su solicitud ha sido enviada a nuestro administrador de cuenta (persona).",
  approvalApplication:
    "Su cuenta estará activa después de que aprobemos su solicitud.",
  passwordResetSuccess: "¡Restablecimiento de contraseña exitoso!",
  resetSuccessful: "Restablecimiento exitoso, la contraseña es 12345678",
  dayTitle: "Perfiles de sensibilidad: L1 = Dia L2 = Noche L3 = Especial",
  creationTime: "Crear tiempo",
  search: "Buscar",
  limits: "Conceder accesso a la cuenta al servicio de asistencia de Jade Bird",
  content:
    "El servicio de atención al cliente ahora tiene acceso a los detalles de su cuenta durante 14 días. Puede revocar el permiso en cualquier momento presionando el botón nuevamente, poniéndolo en estado inactivo.",
  contentLast:
    "Le recomendamos que se asegure de que esta opción esté habilitada cada vez antes de llamar a nuestra línea de soporte.",
  apply: "Aplicación",
  Successful: "Aplicación exitosa",
  msg: "Última solicitud:",
  userName: "Nombre de usuario",
  applicationTime: "Tiempo de soporte",
  showAll: "Mostrar todos los elementos",
  to: "A",
  startDate: "Fecha de inicio",
  endDate: "Fecha final",
  porjectMsg: "Introduzca la palabra clave",
  stateApply: "País de apoyo",
  statusApply: "Hacer posible"
};
